module.exports = __webpack_public_path__ + "static/media/extraImage1.820d88f9.png";